import { differenceInWeeks, endOfQuarter, startOfQuarter } from 'date-fns';
import React, { createContext, useReducer } from 'react';
import { dropDownOptions } from '../containers/DashboardMarketing/index.js';
import dataObject from '../containers/DashboardMarketing/leasingData.js';

//Dashboard Context

const initialState = {
  DashboardTab: {
    buildingName: '',
    dateRange: [startOfQuarter(new Date()), endOfQuarter(new Date())],
    numberWeeks: differenceInWeeks(endOfQuarter(new Date()), startOfQuarter(new Date())),
    lastWeek: new Date('22-Aug-22'),
    filter: 'leasing',
    module: 'analytics',
    portfolio: '',
    isCardOpen: true,
  },
};

export const DashboardContext = createContext(initialState);

export const ContextProvider = ({ children }) => {
  const [dashboardState, dashboardDispatch] = useReducer((dashboardState, action) => {
    switch (action.type) {
      case 'setBuilding':
        // If portfolio has not been set, find and set the portfolio corresponding to building value
        if (!dashboardState.DashboardTab.portfolio) {
          for (const portfolioName of dropDownOptions(dataObject).portfolios) {
            for (const buildingName of dropDownOptions(dataObject)[portfolioName]) {
              if (buildingName === action.payload) {
                return {
                  ...dashboardState,
                  DashboardTab: {
                    ...dashboardState?.DashboardTab,
                    buildingName: action.payload,
                    portfolio: portfolioName,
                  },
                };
              }
            }
          }
        }
        // Otherwise, set building value only
        return { ...dashboardState, DashboardTab: { ...dashboardState?.DashboardTab, buildingName: action.payload } };

      case 'setDateRange':
        if (action.payload && action.payload.length) {
          let [startDate, endDate] = action.payload;
          // Only modify endDate to before 22-Aug-22 if startDate is also less than 22-Aug-22
          // Otherwise, startDate > endDate which will throw an error
          if (endDate > new Date('22-Aug-22') && startDate < new Date('22-Aug-22')) {
            endDate = new Date('22-Aug-22');
          } else if (startDate > new Date('22-Aug-22')) {
            // If startDate is outside date range, set default arbitrary values for both start and end dates
            // This ensures that no error will be thrown
            // E.g. An error may be thrown if start date is 1-Sep-22, and end date is 7-Sep-22
            startDate = new Date('1-Sep-22');
            endDate = new Date('30-Sep-22');
          }
          action.payload = [startDate, endDate];
        }
        console.log({ payload: action.payload, numberWeeks: differenceInWeeks(action.payload[1], action.payload[0]) });
        return {
          ...dashboardState,
          DashboardTab: {
            ...dashboardState?.DashboardTab,
            dateRange: action.payload,
            numberWeeks:
              action.payload && action.payload.length ? differenceInWeeks(action.payload[1], action.payload[0]) : 3,
            lastWeek: action.payload && action.payload.length ? new Date(action.payload[1]) : new Date('22-Aug-22'),
          },
        };
      case 'setFilter':
        return { ...dashboardState, DashboardTab: { ...dashboardState?.DashboardTab, filter: action.payload } };
      case 'setModule':
        return { ...dashboardState, DashboardTab: { ...dashboardState?.DashboardTab, module: action.payload } };
      case 'setPortfolio':
        // whenever portfolio value is changed, reset building value
        // this is because flow should always be set portfolio THEN set building. In other words, there's no reason for buildling value to be set when portfolio value changes
        // If resetting portfolio value, reset building value too
        return {
          ...dashboardState,
          DashboardTab: { ...dashboardState?.DashboardTab, portfolio: action.payload, buildingName: '' },
        };
      // if (!action.payload) {
      // } else {
      //   // Otherwise, set portfolio value only
      //   return { ...dashboardState, DashboardTab: { ...dashboardState?.DashboardTab, portfolio: action.payload } };
      // }
      case 'setYear':
        return { ...dashboardState, DashboardTab: { ...dashboardState?.DashboardTab, year: action.payload } };
      case 'setGraphRange':
        return { ...dashboardState, DashboardTab: { ...dashboardState?.DashboardTab, graphRange: action.payload } };
      case 'toggleCardOpen':
        return {
          ...dashboardState,
          DashboardTab: { ...dashboardState?.DashboardTab, isCardOpen: !dashboardState.DashboardTab.isCardOpen },
        };
      default:
        return dashboardState;
    }
  }, initialState);

  return (
    <DashboardContext.Provider
      value={{
        dashboardState,
        dashboardDispatch,
      }}>
      {children}
    </DashboardContext.Provider>
  );
};
